import { BaseSetting } from 'features/modular-workflow/builder/settings/BaseSetting';

export const DataTypeEmpty = () => {
  return <BaseSetting>{() => null}</BaseSetting>;
};
